import * as THREE from 'three'
import React, { useRef, Suspense } from 'react'
import { Torus, Sphere } from "@react-three/drei"
import { extend, useFrame } from '@react-three/fiber'
import useStore from '../AppStore'
import RingMesh from './RingMesh'
import PlanetThree from './PlanetThree'
import GradientMaterial from '../Shaders/GradientMaterialTorus'

extend({GradientMaterial})

const Planet = React.forwardRef((props,ref) => {

  const torusRef1 = useRef(null)
  const torusRef2 = useRef(null)
  
  useFrame(({clock}) => {
    const top = useStore.getState().top
    torusRef1.current.rotation.x = clock.elapsedTime*0.1*(props.velo||1) + top*0.01
    torusRef2.current.rotation.x = -clock.elapsedTime*0.07*(props.velo||1) - top*0.01
  })
  
  return (
    <group ref={ref} {...props} dispose={null}>
      <PlanetThree scale={[1.5,1.5,1.5]} emission={0.001} />
      <group ref={torusRef1} scale={[1,0.5,1]}>
        <RingMesh>
          <meshPhysicalMaterial transmission={0.9} roughness={0.1} thickness={0.3} envMapIntensity={4} />
        </RingMesh>
      </group>
      <Torus
        ref={torusRef2}
        args={[2.1,0.1,16,64]}
        position={[0,0,0.1]}
        scale={[1,1,1]}
      >
        <gradientMaterial attach="material" uniforms-color1-value={'#FFC700'} uniforms-color2-value={'#9acd32'} />
      </Torus>
    </group>
  )
})

export default Planet
